import React, { useState } from "react";
import { Route } from "react-router-dom";
import { withRouter } from "react-router-dom";
import SideBar from "./components/GenericComponents/Headers/SideBar";
import Header from "./components/GenericComponents/Headers/DefaultHeader";
// import { callApi } from "./lib/utils";

function AuthorizedRoute({ compoenent: Component, ...rest }) {
    /*useEffect(() => {
        callApi("/isAuthenticated", {}, "POST")
            .then((res) => {
                console.log("res: ", res);
                if (res.status === 440) {
                    window.location = "/login";
                }
            })
            .catch((e) => {
                console.log("e: ", e);
            });
    }, []);*/
    //console.log("hesder...",...rest)

    const [state, setState] = useState({ isOpen: false, loading: false });

    const toggle = () => {
        const { isOpen } = state;
        setState({ ...state, isOpen: !isOpen });
    };

    // const logout = (e) => {
    //     e.preventDefault();
    //     console.log("logout..... ");
    //     setState({ ...state, loading: true });
    //     // props.history.push("/logout");
    //     window.location = "/logout";

    //     /*callApi("/api/logout", {}, "POST")
    //         .then((data) => {
    //             console.log("Response: ", data);EntityWorkspacePage
    //             this.setState({ loading: false });
    //             //this.props.history.push("/dashboard");
    //             //this.props.setJwtToken(data.token);
    //         })
    //         .catch((err) => {
    //             console.log("err");
    //         });*/
    // };
    return (
        <div>
            {rest.showHeader ?
                <Header
                toggle={toggle}
                isOpen={state.isOpen}
                //logout={logout}
                ></Header>
            : null}
            {rest.showHeader ?
            <SideBar toggle={toggle} isOpen={state.isOpen} />
            : null }
            <Route
                {...rest}
                render={(props) => {
                    <Component {...props} />;
                }}
            />
        </div>
    );
}

/*const styles = StyleSheet.create({
    app: {
        display: "flex",
        width: "100%",
        alignItems: "stretch",
    },
});*/

export default withRouter(AuthorizedRoute);
